import { useMemo, useState } from 'react';

import { useSort } from '../../hooks';
import { getShortAgents } from '../../api';
import { useUrlParam } from '../../hooks';
import { sortArray } from '../../utilities';
import { searchArray } from '../../utilities';
import { useFetch, useDebouncedValue } from '../../hooks';
import type { AgentCreateRequest } from '../../api';

export type AgentFormType = AgentCreateRequest;

export const useAgents = () => {
  const [showActiveAgents, setShowActiveAgents] = useState(true);
  const [isActive, setIsActive] = useState(false);

  const { loading, data: agentsOptions } = useFetch(
    async () => {
      return await getShortAgents(showActiveAgents);
    },
    [showActiveAgents],
    {
      onSuccess: () => {
        setIsActive(showActiveAgents);
      },
    }
  );

  const { sort, setSort } = useSort();
  const [search, setSearch] = useUrlParam({
    name: 'search',
    defaultValue: '',
    enable: true,
  });

  const debouncedSearch = useDebouncedValue(search || '');

  const agents = useMemo(
    () =>
      sortArray(
        searchArray(agentsOptions ?? [], debouncedSearch, ['title', 'id']),
        sort
      ),
    [agentsOptions, sort, debouncedSearch]
  );

  return {
    loading,
    agents,
    search,
    setSearch,
    sort,
    isActive,
    setSort,
    showActiveAgents,
    setShowActiveAgents,
  };
};
